<template>
    <div class="accordion mb-3">
        <div v-for="(item, index) in itemsComputed"
             :key="'card' + index"
             class="card mb-2"
             :class="{ expanded: item.expanded && !isPassive, passive: isPassive }"
        >
            <div v-if="!isPassive" class="card-header">
                <h2 class="mb-0" :id="item.headerId">
                    <button class="btn btn-block d-flex align-items-center justify-content-between"
                            type="button"
                            data-toggle="collapse"
                            :data-target="'#' + item.value"
                            :aria-expanded="item.expanded"
                            :aria-controls="item.value"
                            @click="toggle(item.value)"
                    >
                        <span class="text-left">{{ item.header }}</span>
                        <IconDropdown class="icon-dropdown pull-right" />
                    </button>

                </h2>
            </div>

            <transition name="slide"
                        @enter="setScrollHeight"
                        @before-leave="setScrollHeight"
                        @after-enter="resetScrollHeight"
            >
                <div v-show="item.expanded"
                    :id="item.value"
                     class="collapse"
                     :aria-labelledby="item.headerId">

                    <div class="card-body">
                        <slot :name="item.value">
                        </slot>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import IconDropdown from "../../../animod-shop-ssr/src/assets/icons/arrow-down.svg";

export default {
    name: 'Accordion',
    components: {
        IconDropdown
    },
    props: {
        items: Array,
        value: String,
        collapsible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        itemsComputed() {
            return this.items.map(item => {
                return {
                    ...item,
                    headerId: item.header.replace(/\s/g, ''),
                    expanded: item.value === this.value,
                };
            });
        },
        //Represents the state when only single item provided
        isPassive() {
            return this.items.length === 1;
        }
    },
    methods: {
        setScrollHeight(element) {
            element.style.height = element.scrollHeight + 'px';
        },
        toggle(value) {
            const newValue = this.collapsible
                ? value === this.value ? "" : value
                : value;
            this.$emit('update:value', newValue);
        },
        resetScrollHeight(element) {
            element.style.height = '';
        }
    }
}
</script>

<style scoped lang="scss">
    @use "@/styles/_variables";
    @use "sass:map";

    $border-color: map.get(variables.$colors, 'border');
    $padding: 15px;

    .accordion {
        .btn:focus,.btn:active {
            outline: none;
            box-shadow: none;
        }


        .card {
            border: 1px solid $border-color;
            border-radius: 0;
            background: hsl(0, 0%, 100%);

            .card-header {
                padding: 0 $padding;
                border: none;
                background: transparent;

                button[data-toggle="collapse"] {
                    padding: $padding 0;
                    border-radius: 0;
                }

                .icon-dropdown {
                    width: 1.5em;
                    color: $border-color;
                    fill: currentColor;
                    transition: transform .3s ease;
                }
            }

            &:not(.passive):hover {
                border-color: hsla(0, 0%, 0%, 0.3);
            }

            &.expanded {
                border-color: map.get(variables.$colors, 'success') !important;

                .card-header {
                    button[data-toggle="collapse"] {
                        border-bottom: 1px solid $border-color;
                    }

                    .icon-dropdown {
                        width: 1.5em;
                        color: $border-color;
                        fill: currentColor;
                        transform: rotate(180deg);
                    }
                }
            }

            &.passive {
                background: transparent;
                border: none;
                overflow: visible;  //prevents card from cutting focused inputs' box-shadow

                .card-body {
                    padding: 0;
                }
            }
        }

        .collapse {
            display: block;
        }

        .slide-enter-active,  .slide-leave-active {
            position: relative;
            overflow: hidden;
            transition: height 0.3s ease-in-out;
        }

        .slide-enter, .slide-leave-to {
            height: 0 !important;
        }
    }
</style>
